import {
   Add_Terminal_Loading , 
   Add_Terminal_Success,
   Add_Terminal_Reset, 
   Add_Terminal_Failed
   
  } from "../types";
  
  const initialState = {
    loading: false,
    error: null,
    TSN: null,
    status: null,
  };
  
  export const AddTerminalReducer = (
    state = initialState,
    action: { type: any; loading: any; payload: any; status: any; error: any }
  ) => {
    switch (action.type) {
      case Add_Terminal_Loading:
        return {
          ...state,
          loading: action.loading,
        };
      case Add_Terminal_Success:
        return {
          ...state,
          loading: false,
          TSN: action.payload,
          status: action.status,
          error: null,
        };
      case Add_Terminal_Failed:
        return {
          ...state,
          loading: false,
          TSN: null,
          status: null,
          error: action.error,
        };
      default:
        return state;
    }
  };
  